var utils = require('./extrax2-webadmin.utils.js');
var validator = require('./extrax2-webadmin.validator.js');
var ajax = require('./extrax2-webadmin.ajax.js');
var initialize = require('./extrax2-webadmin.initialize.js');

function saveChanges(e) {

	return $.Deferred(function (defer) {
		var el = e.target;
		//console.log('saveChanges');
		//console.log(el);
		//console.log(window.location.pathname);

		if (!utils.GLOBALS.programmaticClick) {
			var form = null;
			var content_detail = document.getElementById("content-detail-modal");
			if (utils.isUndefined(content_detail) || (!utils.isUndefined(content_detail) && !content_detail.contains(el))) {

				content_detail = document.getElementById("content-modal");

				if (utils.isUndefined(content_detail) || (!utils.isUndefined(content_detail) && !content_detail.contains(el))) {
					content_detail = document.getElementById("content-sub-detail");

					if (utils.isUndefined(content_detail) || (!utils.isUndefined(content_detail) && !content_detail.contains(el))) {
						content_detail = document.getElementById("content-detail");
					}
				}

				form = $(content_detail).find('.tt-check-changes-form');

			} else {
				form = $(el).parents('.tt-content-dialog').find('.tt-check-changes-form');
			}

			// if (!utils.isUndefined(form)) {
			// 	console.log(form);
			// 	console.log(form.hasClass('dirty'));
			// }

			var elementIsOnForm = false;
			jQuery.each(form, function (i, singleForm) {
				if ($(singleForm).parents('.portlet-body,.tt-portlet-global').length > 0 && $(singleForm).parents('.portlet-body,.tt-portlet-global')[0].contains(el)
					&& !($(el).hasClass('tt-create-base-license') || $(el).hasClass('tt-create-license') || $(el).hasClass('tt-create-xsd') || $(el).hasClass('tt-send-update-info-mail'))) {
					elementIsOnForm = true;
				}
			});

			if (!utils.isUndefined(form) && form.hasClass('dirty')
				&& ($(el).is('a,button,td,.dd-handle,.dd3-content') || $(el).parents('a,button,.tt-datatable td,.dd-handle,.dd3-content').length) && $(el).parents('.bootbox').length <= 0 && $(el).parents('.sweet-alert').length <= 0
				&& (form.parents('.portlet-body,.tt-portlet-global').length > 0 && !elementIsOnForm)
				&& !/^bot/.test(el.id) && !$(el).is('.btn-header') && !$(el).parents('.btn-header').length && !$(el).parents('.ui-datepicker-calendar').length) {

				// console.log("1");
				var parents = $(el).parents('a,button,.tt-datatable td,.dd-handle');

				var doSaveChanges = true;
				// Buttons zum Aus- Einklappen nicht berücksichtigen
				// Buttons zum Anzeigen der Tabs
				if (doSaveChanges && (($(el).is('button') && !utils.isUndefined($(el).data().action) && ($(el).data().action == 'collapse' || $(el).data().action == 'expand'))
					|| ($(el).is('a') && !utils.isUndefined($(el).data().toggle) && $(el).data().toggle == 'tab'))) {
					doSaveChanges = false;
				}
				// console.log(doSaveChanges);
				// Löschen, Speichern und Tabelle weiter und zurück dürfen nicht berücksichtigt werden
				if (doSaveChanges && (!($(el).hasClass('tt-delete') || $(el).hasClass('tt-save') || $(el).hasClass('tt-save-sub-form') || $(el).hasClass('tt-datatable-previous') || $(el).hasClass('tt-datatable-next')
					|| $(el).hasClass('ui-datepicker-next') || $(el).hasClass('ui-datepicker-prev') || $(el).hasClass('tt-doc-tab') || $(el).hasClass('bootbox-btn') || $(el).hasClass('btn-form') || $(el).hasClass('bootbox-close-button')
					|| $(el).hasClass('tt-back-from-contract') || $(el).hasClass('tt-back-from-calculation') || $(el).hasClass('tt-check-all') || $(el).hasClass('tt-check-none')
					|| parents.hasClass('tt-delete') || parents.hasClass('tt-save') || parents.hasClass('tt-save-sub-form') || parents.hasClass('tt-doc-tab') || parents.hasClass('tt-datatable-previous') || parents.hasClass('tt-datatable-next')
					|| parents.hasClass('ui-datepicker-next') || parents.hasClass('ui-datepicker-prev') || parents.hasClass('bootbox-btn') || parents.hasClass('btn-form') || parents.hasClass('tt-back-from-contract')
					|| parents.hasClass('tt-back-from-calculation') || parents.hasClass('tt-check-all') || parents.hasClass('tt-check-none') || parents.hasClass('note-editor') || $(el).parents('.bootstrap-timepicker-widget').length)
					|| $(el).hasClass('tt-create-base-license') || $(el).hasClass('tt-create-license') || $(el).hasClass('tt-create-xsd') || $(el).hasClass('tt-send-update-info-mail'))) {

					// console.log("2");
					e.stopPropagation();
					e.preventDefault();

					if ($(el).hasClass('tt-create-base-license') || $(el).hasClass('tt-create-license') || $(el).hasClass('tt-create-xsd') || $(el).hasClass('tt-send-update-info-mail')) {
						var messageText = Lang.get('extrax2-webadmin.save_changes_before_create_license');
						if ($(el).hasClass('tt-create-base-license')) {
							messageText = Lang.get('extrax2-webadmin.save_changes_before_create_base_license');
						} else if ($(el).hasClass('tt-create-xsd')) {
							messageText = Lang.get('extrax2-webadmin.save_changes_before_create_xsd');
						} else if ($(el).hasClass('tt-send-update-info-mail')) {
							messageText = Lang.get('extrax2-webadmin.save_changes_before_send_update_info_mail');
						}
						bootbox.dialog({
							message: messageText,
							title: Lang.get('extrax2-webadmin.unsaved_changes'),
							buttons: {
								yes: {
									label: Lang.get('extrax2-webadmin.yes'),
									className: "btn btn-success bootbox-btn",
									callback: function () {
										if (form.valid()) {
											var saveButton = form.parents('.portlet').find('.tt-save');
											if (saveButton.length < 0 || utils.isUndefined(saveButton[0])) {
												saveButton = form.parents('.tt-portlet-global').find('button[type="submit"]');
											}

											if ($(el).hasClass('tt-send-update-info-mail') && !$(form).find('[name="is_beta_version"]')[0].checked && $(form).find('[name="is_beta_version"]').data().initValue && $(form).find('[name="is_productive_version"]')[0].checked) {
												$('#send_update_info').val('1');
											} else {
												utils.updateGlobals('elementToClickAfterSave', el);
											}
											saveButton.click();
										}
									}
								},
								cancel: {
									label: Lang.get('extrax2-webadmin.cancel'),
									className: "btn btn-danger bootbox-btn",
									callback: function () {
									}
								}
							}
						});
					} else {
						bootbox.dialog({
							message: Lang.get('extrax2-webadmin.save_changes'),
							title: Lang.get('extrax2-webadmin.unsaved_changes'),
							buttons: {
								yes: {
									label: Lang.get('extrax2-webadmin.yes'),
									className: "btn btn-success bootbox-btn",
									callback: function () {
										if (form.valid()) {
											var saveButton = form.parents('.portlet').find('.tt-save');
											if (saveButton.length < 0 || utils.isUndefined(saveButton[0])) {
												saveButton = form.parents('.tt-portlet-global').find('button[type="submit"]');
											}

											utils.updateGlobals('elementToClickAfterSave', el);
											saveButton.click();
										}
									}
								},
								no: {
									label: Lang.get('extrax2-webadmin.no'),
									className: "btn btn-warning bootbox-btn",
									callback: function () {

										form.validate().resetForm();
										form.trigger('reinitialize.areYouSure');
										// console.log(el);
										validator.clickElement(el, true);
									}
								},
								cancel: {
									label: Lang.get('extrax2-webadmin.cancel'),
									className: "btn btn-danger bootbox-btn",
									callback: function () {
									}
								}
							}
						});
					}
				}
			} else {
				if ((!/^bot/.test(el.id) && !$(el).is('.btn-header') && !$(el).parents('.btn-header').length && !$(el).parents('.ui-datepicker-calendar').length && el.id !== 'hide-menu' && $(el).parents().id !== 'hide-menu' && (!utils.isUndefined(el.hash) && !/^#/.test(el.hash))
					&& (!utils.isUndefined($(el).parents('a,button,.tt-datatable td').hash) && !/^#/.test($(el).parents('a,button,.tt-datatable td').hash)))
					|| $(el).is('.dd-handle')) {
					validator.clickElement(el);
				}
			}
		} else {
			if ((!/^bot/.test(el.id) && !$(el).is('.btn-header') && !$(el).parents('.btn-header').length && !$(el).parents('.ui-datepicker-calendar').length && el.id !== 'hide-menu' && $(el).parents().id !== 'hide-menu' && (!utils.isUndefined(el.hash) && !/^#/.test(el.hash))
				&& (!utils.isUndefined($(el).parents('a,button,.tt-datatable td').hash) && !/^#/.test($(el).parents('a,button,.tt-datatable td').hash)))
				|| $(el).is('.dd-handle')) {
				validator.clickElement(el);
			}
		}

		defer.resolve(true);
	});
}

function reloadTable(table, url) {
	$(table).DataTable().ajax.url(url).load();

	$(table).parents('.tt-content-datatable').parents('.portlet').find('.tt-delete').addClass('disabled');
	$(table).parents('.tt-content-datatable').parents('.portlet').find('.tt-delete').prop('disabled', 'disabled');
}

function tableSingleClick(element, childElement) {
	return $.Deferred(function (defer) {

		// Element nach dem Speichern wieder finden
		if (!utils.isUndefined(element[0].id)) {
			var table_id = null;
			if (utils.isUndefined(element.parents('.tt-datatable,.tt-datatable-data')[0])) {
				table_id = $('#' + element[0].id).parents('.tt-datatable,.tt-datatable-data')[0].id;
			} else {
				table_id = element.parents('.tt-datatable,.tt-datatable-data')[0].id;
			}
			element = $('#' + table_id).find('#' + element[0].id);
		}

		var aPos = element.parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-data').dataTable().fnGetPosition(element[0]);
		var aData = element.parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-data').dataTable().fnGetData(aPos);

		if (!element.hasClass('active')) {
			if (element.parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-data')[0].id === 'table_doc_documents' || element.parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-data')[0].id === 'table_audit_trail') {
				defer.resolve();
				return;
			} else {
				element.parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-data').dataTable().$('tr.active').removeClass('active');
				element.addClass('active');
			}
		}

		var initializeElements = true;
		var newUrl = element.parents('.tt-content-datatable').find('.tt-datatable,.tt-datatable-data')[0].getAttribute('data-table-url') + "/" + element[0].id;

		tableSingleClickAjaxCall(element, newUrl, aPos, aData, initializeElements)
			.done(function () {
				defer.resolve();
			});
	}).promise();
}

function tableSingleClickAjaxCall(element, newUrl, aPos, aData, initializeElements) {
	return $.Deferred(function (defer) {

		ajax.ajaxCallDeferred(newUrl, 'GET', null, false)
			.done(function (data) {
				if (ajax.ajaxSucceeded(data)) {

					if (element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_account_draw_up_history") {
						utils.setHtmlData($("#content"), data, initializeElements);
					} else {
						// Löschen-Button aktiv setzen, wenn eine Zeile ausgewählt wurde, außer:
						// Es handelt sich um die Benutzer-Tabelle und der Benutzer 'administrator' wurde ausgewählt
						if (!(element.parents('.tt-datatable,.tt-datatable-data').length && (element.parents('.tt-datatable,.tt-datatable-data')[0].id === "table_users" && aData.length >= 3 && aData[2] === "administrator"))) {
							element.parents('.tt-content-datatable').parents('.portlet').find('.tt-delete').removeClass('disabled');
							element.parents('.tt-content-datatable').parents('.portlet').find('.tt-delete').removeAttr('disabled');
						} else {
							element.parents('.tt-content-datatable').parents('.portlet').find('.tt-delete').addClass('disabled');
							element.parents('.tt-content-datatable').parents('.portlet').find('.tt-delete').prop('disabled', 'disabled');
						}

						if (element.parents('.tt-content-datatable').find('.tt-selected-pos').length > 0) {
							element.parents('.tt-content-datatable').find('.tt-selected-pos').val(aPos);
						}

						utils.setHtmlData($("#content-detail"), data, initializeElements);

						if (aData[3] !== null && (utils.stringToDate(aData[3]) < new Date())){
							$("#set_next_export_to_initial_export").addClass('hidden');
							$("#next_export_is_initial_export_info").attr('hidden');
                     $("#set_do_export_immediately").addClass('hidden');
                     $("#do_export_immediately").attr('hidden');
						}

						if ($("#content-detail").find('input:text').length) {
							$("#content-detail").find('input:text')[0].focus();
						}
					}

					defer.resolve();
				} else {
					defer.reject();
				}
			})
			.fail(function () {
				defer.reject();
			});
	}).promise();
}

function tableDoubleClick(element) {

	var aPos = element.parents('.tt-datatable,.tt-datatable-data').dataTable().fnGetPosition(element.parent()[0]);
	var aData = element.parents('.tt-datatable,.tt-datatable-data').dataTable().fnGetData(aPos);

}

module.exports.saveChanges = saveChanges;
module.exports.reloadTable = reloadTable;
module.exports.tableSingleClick = tableSingleClick;
module.exports.tableSingleClickAjaxCall = tableSingleClickAjaxCall;
module.exports.tableDoubleClick = tableDoubleClick;
